namespace TabAurous.HR {
    export interface AttendanceRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        CompanyId?: number;
        VoucherTypeId?: number;
        UserId?: number;
        Details?: AttendanceDetailsRow[];
    }

    export namespace AttendanceRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'HR.Attendance';
        export const deletePermission = 'HR:Attendance:Delete';
        export const insertPermission = 'HR:Attendance:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:Attendance:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            CompanyId = "CompanyId",
            VoucherTypeId = "VoucherTypeId",
            UserId = "UserId",
            Details = "Details"
        }
    }
}
